module.exports = __webpack_public_path__ + "static/media/icon-truck.2496ed2f.svg";